// extracted by mini-css-extract-plugin
export default {"chartMain":"chart_chartMain__SI72C","chartRow":"chart_chartRow__MTnAZ","chartRowTwo":"chart_chartRowTwo__7YPyu","singleChart":"chart_singleChart__eWjgB"};